import { render, staticRenderFns } from "./CplusTerms.vue?vue&type=template&id=5ac8f923&scoped=true&"
import script from "./CplusTerms.vue?vue&type=script&lang=js&"
export * from "./CplusTerms.vue?vue&type=script&lang=js&"
import style0 from "./CplusTerms.vue?vue&type=style&index=0&id=5ac8f923&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8f923",
  null
  
)

export default component.exports